import React, { SVGProps } from 'react'

export const ScalesSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      d="M23.988 17.004C24.115 18.1 23.2 19 22.085 19h-8.803l3.657-6.682c.162-.296-.215-.591-.468-.367L8.53 19H1.915C.8 19-.115 18.1.012 17.004.797 10.217 5.559 5 12 5c6.44 0 11.203 5.217 11.988 12.004Z"
    />
  </svg>
)
